import Feature from 'ol/Feature';
import {Point} from 'ol/geom';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {fromLonLat} from 'ol/proj';
import {hexToRGBA} from "@/assets/js/utils";

/**
 * Earthquake animation — concentric seismic waves pulsing from the epicenter.
 *
 * Expected `data` shape:
 *   { "center": [lon, lat], "magnitude": 6.5 }
 */
export function earthquake(layer, news, data) {
    const epicenter = fromLonLat(data.center);
    const magnitude = Math.max(1, data.magnitude || 5);
    const baseRadius = 2 + magnitude * 2;
    const maxRadius = baseRadius * 4;

    const parent = new Feature({
        geometry: new Point(epicenter),
        where: epicenter
    });
    parent.setStyle(new Style({
        image: new CircleStyle({
            radius: baseRadius,
            fill: new Fill({color: hexToRGBA(news.color, 0.9)}),
            stroke: new Stroke({color: '#fff', width: 2})
        })
    }));
    layer.getSource().addFeature(parent);

    const RING_COUNT = 5;
    const rings = [];
    for (let i = 0; i < RING_COUNT; i++) {
        const ring = new Feature({geometry: new Point(epicenter)});
        ring.set('selectable', false);
        ring.set('_progress', i / RING_COUNT);
        rings.push(ring);
        layer.getSource().addFeature(ring);
    }

    setInterval(() => {
        rings.forEach(ring => {
            let p = ring.get('_progress') + 0.02;
            if (p > 1) p = 0;
            ring.set('_progress', p);
            const radius = baseRadius + (maxRadius - baseRadius) * p;
            const alpha = (1 - p) * 0.55;
            ring.setStyle(new Style({
                image: new CircleStyle({
                    radius,
                    stroke: new Stroke({
                        color: hexToRGBA(news.color, alpha),
                        width: 2
                    })
                })
            }));
        });
    }, 50);

    return {
        getFeature() {
            return parent;
        }
    };
}
